import { Reducer } from "redux";

import { AccomodationMasterResponse } from "../models/Api/Master";
import { AccomodationDispatchTypes } from "../models/DispatchTypes/Master";
import { AccomodationMasterActionDispatchTypes } from "../constants/Master";
import { setLocalStorageData } from "../utils";

export const initialState: AccomodationMasterResponse = {
  loading: false,
  response: [],
};

const MasterAccomodationReducer: Reducer<
  AccomodationMasterResponse,
  AccomodationDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case AccomodationMasterActionDispatchTypes.ACCOMODATION_MASTER_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case AccomodationMasterActionDispatchTypes.ACCOMODATION_MASTER_SUCCESS: {
      setLocalStorageData(
        AccomodationMasterActionDispatchTypes.ACCOMODATION_MASTER_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case AccomodationMasterActionDispatchTypes.ACCOMODATION_MASTER_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default MasterAccomodationReducer;
